angular
    .module('app.controllers')
    .controller('ReportsPeriodSummaryCtrl', function ($rootScope, $scope, $translate, $httpParamSerializerJQLike, api, usersOptions, groupsOptions, phaseStatusOptions) {
        const vm = this;

        vm.for_who = 'crew_id';
        vm.print = {
            date_from: moment().format('YYYY-MM-DD'),
            date_to: moment().format('YYYY-MM-DD'),
        };
        vm.types = ['measurement', 'installation', 'transport', 'service'];

        vm.usersOptions = usersOptions;
        vm.groupsOptions = groupsOptions;
        vm.phaseStatusOptions = phaseStatusOptions;

        vm.getUrl = () => `/reports/download/period_summary?${$httpParamSerializerJQLike(vm.print)}`;

        vm.clientsOptions = [];
        vm.investments = [];
        vm.investmentOptions = [];

        api('investments')
            .list()
            .then((response) => {
                vm.investments = response.data;
            });

        $scope.$watch('ReportsPeriodSummary.client_id', (client_id) => {
            vm.updateInvestments(client_id);
        });
        vm.updateInvestments = function (client_id) {
            if (!client_id) {
                vm.investment_id = 0;
                vm.investmentOptions = [];
            } else {
                vm.investmentOptions = vm.investments
                    .filter((investment) => investment.client_id == vm.client_id)
                    .map((investment) => ({
                        value: investment.id,
                        label: investment.name,
                    }));
            }
        };

        vm.getUrl2 = () => `/reports/download/service_work?investment_id=${vm.investment_id}`;
    });
